var mixUserColor = {
  data() {
    return {
      colorsPack: [
        "pink",
        "purple",
        "deep-purple",
        "indigo",
        "blue",
        "light-blue",
        "cyan",
        "teal",
        "green",
        "light-green",
        "lime",
        "yellow",
        "amber",
        "orange",
        "deep-orange",
        "blue-grey"
      ]
    };
  },
  computed: {
    colorCuaderno() {
      return this.userConfig
        ? this.colorsPack[this.userConfig.cua.color] +
            " lighten-" +
            this.userConfig.cua.light
        : "";
    },
    colorName() {
      return this.userConfig ? this.colorsPack[this.userConfig.cua.color] : "";
    },
    colorText() {
      return this.userConfig
        ? this.colorsPack[this.userConfig.cua.color] + "--text text--darken-3"
        : "";
    }
  }
};

export default mixUserColor;
